@if (field.attributeCode === 'allow_booking_start_time' || field.attributeCode === 'allow_booking_end_time') {
    <form [formGroup]="formName">
        <p-calendar [showTime]="true" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" [timeOnly]="true" 
            [hourFormat]="hourFormat" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" 
            class="w-full" [placeholder]="placeholder">
            <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                <i class="pi pi-clock cursor-pointer" (click)="clickCallBack($event)"></i>
            </ng-template>
        </p-calendar>
    </form>
} @else if(this.moduleName === 'site_delivery_address') {
    <form [formGroup]="formName">
        <p-calendar [showTime]="true" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" [timeOnly]="true" 
            [hourFormat]="hourFormat" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" 
            class="w-full" [placeholder]="placeholder" [ngClass]="{'ng-invalid': formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.errors?.timeRange}">
            <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                <i class="pi pi-clock cursor-pointer" (click)="clickCallBack($event)"></i>
            </ng-template>
        </p-calendar>
        @if(formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.errors?.timeRange) {
            <small class="text-red-500 text-base">
                {{ field.attributeCode === 'delivery_time_from' ? ('delivery_time.start_time_before_end' | translate) : ('delivery_time.end_time_after_start' | translate) }}
            </small>
        }
    </form>
} @else {
    <form [formGroup]="formName">
        <p-calendar [showTime]="true" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" [timeOnly]="true" 
            [hourFormat]="hourFormat" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" 
            class="w-full" [placeholder]="placeholder" [ngClass]="{'ng-invalid': formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.errors?.timeRange}">
            <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                <i class="pi pi-clock cursor-pointer" (click)="clickCallBack($event)"></i>
            </ng-template>
        </p-calendar>
        @if(formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.errors?.timeRange) {
            <small class="text-red-500 text-base">
                {{ field.attributeCode === 'delivery_time_from' ? ('delivery_time.start_time_before_end' | translate) : ('delivery_time.end_time_after_start' | translate) }}
            </small>
        }
    </form>
}